import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LoaderService } from './loader.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {

  constructor(
    private loaderService: LoaderService,
    private toastr: ToastrService,
    private router: Router,
    private translateService: TranslateService
  ) { }

  formatErrorMessage(errorResponse: HttpErrorResponse): string {
    let errorMessage = '';
    const responseErrorMessages = Object.values(errorResponse.error.errors);
    responseErrorMessages.forEach((message: string) => {
      errorMessage += message + '\n';
    });
    return errorMessage;
  }

  handleBackendError(response: HttpErrorResponse): Observable<never> {
    this.loaderService.hide();
    let errorMessage: string;

    if (response.status === 0 || response.error?.errors === null) {
      errorMessage = this.translateService.instant('SHARED.SOMETHING_WENT_WRONG');
    } else if (response.status === 403) {
      if (response.error.errors === 'Access Denied.' ||
          response.error.errors === 'Unfortunately, there is no authority to log in, if this is not correct consult your nearest manager.') {
          errorMessage = response.error.errors;
          this.router.navigate(['/login']);
      } else {
        errorMessage = this.formatErrorMessage(response);
      }
    } else if (response.status === 401) {
      errorMessage = response.error.message;
    } else if (response.status === 415) {
      errorMessage = this.translateService.instant('GENERIC_ERROR_MESSAGES.UNSUPPORTED_FORMAT');
    } else if (typeof response.error.errors === 'string') {
      errorMessage = response.error.errors;
    } else {
      errorMessage = this.formatErrorMessage(response);
    }

    this.toastr.error(errorMessage);
    return throwError(() => response);
  }

  handleMediaError(response: HttpErrorResponse): Observable<never> {
    this.loaderService.hide();
    this.toastr.error(response.message);
    return throwError(() => response);
  }

  handleAdwayError(response: HttpErrorResponse): Observable<never> {
    if (response?.error?.validation_errors) {
      let errorMessage = this.translateService.instant('JOB_PLATFORMS.ADWAY.ADWAY_VALIDATION_DID_NOT_PASS') + '\n';
      response.error.validation_errors.forEach((entry) => {
        errorMessage += entry.path[0] + ': ' + entry.message + ', \n';
      });

      response.error.errors = errorMessage;
    }

    return throwError(() => response);
  }
}
